<template>
  <div class="content">
    <Spinner :isLoading="isLoading" />
    <div>
      <b-container fluid class="mt--7">
        <b-row>
          <b-col xl="12">
            <card>
              <b-row>
                <b-col :xl="windowWidth >= 1200 && windowWidth < 1300 ? 4 : 3" lg="4" md="5" class="p-1">
                  <span class="text">Settings Time: </span>
                  <el-dropdown trigger="click" @command="handleCommand">
                    <el-button>
                      {{ activeName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="Year">Year</el-dropdown-item>
                      <el-dropdown-item command="Month">Month</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </b-col>
                <b-col :xl="windowWidth >= 1200 && windowWidth < 1300 ? 5 : 4" lg="5" md="6" class="p-1">
                  <span class="text">Calendar: </span>
                  <el-date-picker class="mobile-calendar" v-if="activeIndex === 0" v-model="year" type="year"
                    align="right" :clearable="false" :picker-options="pickerOptions" default-time="2021"
                    placeholder="Pick a year">
                  </el-date-picker>
                  <el-date-picker class="mobile-calendar" v-if="activeIndex === 1" v-model="month" type="month"
                    align="right" :clearable="false" :picker-options="pickerOptions" placeholder="Pick a month">
                  </el-date-picker>
                </b-col>
                <b-col :xl="2" lg="2" md="12" class="layout p-1">
                  <button @click="getData()" class="btn base-button btn-danger submit">Submit</button>
                </b-col>
              </b-row>
            </card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { Button, DatePicker, Dropdown, DropdownItem, DropdownMenu } from "element-ui";
import { BasePagination } from "@/components";
import { Table, TableColumn, Select, Option, Notification } from "element-ui";
import { appFunctions } from "../../helpers/appFunctions";
import { GlobalStore } from "../../globalStore";
import { formattingMethods } from "../../helpers/formatting";
import DialogConfirm from "../components/DialogConfirm.vue";
import DialogResume from "../components/DialogResume.vue";
import DialogDiscard from "../components/DialogDiscard.vue";
import CancelPolicies from "../CancelPolicies.vue";
import Spinner from "../dashboard/Spinner.vue";

import moment from 'moment';
export default {
  props: {
  },
  name: "menu-bar",
  data() {
    return {
      renewalData: [],
      windowWidth: window.innerWidth,
      month: "",
      year: "",
      isLoading: false,
      loading: false,
      activeName: "Month",
      activeIndex: 1,
      pickerOptions: {
        disabledDate(time) {
          return !moment(time.getTime()).isBetween('2022-01-01', Date.now());
        },
      },
      title: '',
      quoteCancel: null,
      isCancel: false,
      message: '',
      discardDialog: false,
      titleDigLog: '',
      selectedRow: null,
      cancelConfirmModal: false,
      centerDialogVisible: false,
    };
  },
  mounted() {
    this.month = Date.now()
    this.year = Date.now()
    this.fetchData();
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    async goStepCancel() {
      this.isCancel = false
      this.cancelConfirmModal = false
      this.centerDialogVisible = false
      this.discardDialog = false
      //await this.getCustomerLCPolicies(true)
    },
    getRowKeys(row) {
      return row._id
    },
    setLoading(val) {
      this.isLoading = val
    },
    myEventHandler(e) {
      this.windowWidth = window.innerWidth
    },
    modelPopupCancel() {
      this.cancelConfirmModal = false
    },
    modelPopupResume() {
      this.centerDialogVisible = false
    },
    modelPopupDiscard() {
      this.discardDialog = false
    },
    handleContinuePolicies() {
      this.quoteId = this.quoteCancel.quoteId
      this.$router.push("/lightCommercial/policies?qg=" + this.quoteId);
      this.isCancel = true
    },
    async handleCallAPI(method) {
      this.isLoading = true
      const policyId = this.selectedRow.Ubind_quote_details_obj.policyId;
      await method(policyId)
        .then(resp => {
          this.quoteId = resp.quoteId
          this.isCancel = true;
          this.$router.push("/lightCommercial/policies?qg=" + this.quoteId);
          this.isLoading = false
        })
        .catch(err => {
          if (!err.response.data.data) {
            Notification.error({
              title: 'Error',
              message: 'You are missing the required permission!'
            });
          } else {
            this.quoteCancel = err.response.data.data
            this.cancelConfirmModal = false
            this.message = err.response.data.detail
            if (err.response.data.code.includes("exists.when")) {
              this.discardDialog = true
            } else {
              this.centerDialogVisible = true
            }
          }
        });
      this.isLoading = false
    },
    getData() {
      let year = null
      let month = null
      if (this.activeIndex === 0) {
        year = moment(this.year).year()
        month = 1 + moment(this.year).month()
      } else {
        year = moment(this.month).year()
        month = 1 + moment(this.month).month()
      }
      this.$emit('getDataChart', year, month, this.activeIndex, this.month)
    },
    handleCommand(command) {
      this.activeName = command
      const index = command === 'Year' ? 0 : 1
      this.activeIndex = index
    },
    formatPremium(row) {
      const totalPayable =
        row.Customer_policy_insurance_total_payable &&
        row.Customer_policy_insurance_total_payable.toString().replace("$", "");
      return "$" + formattingMethods.numberWithCommas(totalPayable);
    },
    formatDateWithSlash(dateVal) {
      if (dateVal) {
        return dateVal.replaceAll('/', '-')
      } else {
        return "N/A"
      }
    },
    formatDateTime(dateVal) {
      return formattingMethods.formatDateTime(dateVal);
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
    },
    handlePolicyModals(row, type) {
      const titles = {
        adjustment: `Are you sure you want to make \n an adjustment to policy ${row.policy_number}`,
        cancellation: `Are you sure you want to initiate \n cancellation of policy ${row.policy_number}?`,
        renew: `Are you sure you want to renew \n policy ${row.policy_number}?`
      }
      this.title = type
      this.titleDigLog = titles[type]
      this.selectedRow = null
      this.cancelConfirmModal = true
      this.selectedRow = row;
    },
    fetchData() {
      this.loading = true;
      appFunctions
        .crud_customerLCPolicy("listRenewalsByRealmId", {
          Realm_user_id: GlobalStore.brokerObj.Realm_user_id,
          type: "policy"
        })
        .then(resp => {

          this.loading = false;

          console.log(resp);
          var tdata = resp.data.data;



          tdata.forEach(q => {

            // Formatting number values.
            if (q.Ubind_quote_details_obj) {
              q.policy_number = q.Ubind_quote_details_obj.policyNumber || "";
              q.last_modified = q.Ubind_quote_last_updated_date;
            }

            q.Broker_Name = q.createdByName
            q.isDisableCancel = q.Ubind_status === 'complete' ? false : true
            q.isDisableAdjust = true
            q.isDisableRenew = true
            q.Ubind_status = this.capitalizeFirstLetter(q.Ubind_status);


            //const policyEndDate =  q.Ubind_quote_details_obj.formDataFormatted.policyEndDate ||
            //  q.Ubind_quote_details_obj.formData.policyEndDate;
            // const convertedPolicyEndDate = moment(convertDateToHyphen(policyEndDate));

            // // daysUntilExpired is negative value if current date is before policyEndDate
            // const daysUntilExpired = moment().diff(convertedPolicyEndDate, "days");

            //console.log(policyEndDate);
          });

          tdata.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return (
              new Date(b.Ubind_quote_created_date) -
              new Date(a.Ubind_quote_created_date)
            );
          });

          this.renewalData = tdata;

          // this.initFuse([
          //   "Customer_insured_name",
          //   "Quote_Ref_No",
          //   "Status",
          //   "Broker_Name",
          //   "Broker_Org_Name"
          // ]);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    DialogConfirm,
    CancelPolicies,
    DialogResume,
    DialogDiscard,
    Spinner
  },
};
</script>

<style scoped>
.text-danger {
  font-size: 2.5em;
}

.border-button {
  border-radius: 20px !important;
  border: 1px solid white;
  background: #f7fafc !important;
}

.active {
  border: 1px solid #ff4438;
}

.font-color {
  color: black;
}

.submit {
  border-radius: 20px;
}

.title {
  text-align: center;
  margin-right: 10px;
  font-weight: 600;
  margin-top: 2px;
}

@media only screen and (min-width: 340px) and (max-width: 1240px) {
  .layout {
    text-align: center;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1459px) {
  .layout {
    text-align: center;
  }
}

@media only screen and (min-width: 414px) and (max-width: 768px) {
  .mobile-calendar {
    margin-left: 30px;
  }

  .mobile-status {
    margin-left: 30px;
  }

  .text {
    font-size: 15px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 414px) {
  .mobile-calendar {
    margin-left: 28px;
  }

  .mobile-status {
    margin-left: 50px;
  }

  .text {
    font-size: 15px;
  }
}</style>
